import { MenuOrientation } from '../../constants';
import type { MenuOrientationType, IMenuCssVars } from '../../Menu.types';

export const orientationToCssVarsMap: Record<
  MenuOrientationType,
  IMenuCssVars
> = {
  [MenuOrientation.Horizontal]: {
    '--flex-direction': 'row',
  },
  [MenuOrientation.Vertical]: {
    '--flex-direction': 'column',
  },
};
